import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlSignature } from '../common/apiEndpoint';
import { SuperloginService } from '../superlogin/superlogin.service'; // ← same import as working component

@Injectable({
  providedIn: 'root'
})
export class ApplicationfeesdashboardService {

  constructor(
    private http: HttpClient,
    private urls: UrlSignature,
    private authService: SuperloginService  // ← inject exactly like the working component
  ) {}

  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken() || '';  // ← exact same as working component
    return new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    });
  }

  getSummary(): Observable<any> {
    return this.http.get<any>(this.urls.summaryUrl, { headers: this.getHeaders() });
  }

  getAllTransactions(): Observable<any[]> {
    return this.http.get<any[]>(this.urls.getalltransacionsurl, { headers: this.getHeaders() });
  }

  getSuccessfulTransactions(): Observable<any[]> {
    return this.http.get<any[]>(this.urls.successapplicationpaymenturl, { headers: this.getHeaders() });
  }

  getPendingTransactions(): Observable<any[]> {
    return this.http.get<any[]>(this.urls.pendingapplicationpaymenturl, { headers: this.getHeaders() });
  }

  getFailedTransactions(): Observable<any[]> {
    return this.http.get<any[]>(this.urls.failedapplicationpaymenturl, { headers: this.getHeaders() });
  }

  getTransactionDetail(checkoutId: string): Observable<any> {
    return this.http.get<any>(
      this.urls.transactionDetailUrl + checkoutId,
      { headers: this.getHeaders() }
    );
  }

  getTransactionsByTab(tab: string): Observable<any[]> {
    switch (tab) {
      case 'successful': return this.getSuccessfulTransactions();
      case 'pending':    return this.getPendingTransactions();
      case 'failed':     return this.getFailedTransactions();
      default:           return this.getAllTransactions();
    }
  }
}